export const calculateTargetMissingQuantity = (sku, accountLocations, locations) =>
  sku.inventoryBreakdown
    .filter((location) => accountLocations.some(({ node }) => node._id === location._id))
    .filter(
      (location) =>
        location.replenishmentStatus === 'replenishNow' &&
        (locations.length > 0 ? locations.includes(location._id) : true),
    )
    .reduce((acc, location) => acc + location.targetMissingInventoryQuantity, 0);
